import { api } from '../config'

export const EVENTSBOARD_URL = {
  getEventsProps: (eventName: string) =>
    `${api.withAPI}administrative/api/v1/admin/analytics/${eventName}/props`,
}
